import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, BoxProps, Typography } from '@mui/material';
import CityStore from '@components/offer/stores/CityStore';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';

interface CityNameProps {
    cityStore: CityStore;
}

const CityName: React.FC<CityNameProps> = observer(({ cityStore }) => {
    const { selectedCity } = cityStore;
    return (
        <Box display={"flex"} flexDirection={"row"} alignItems={"center"} mb={2}>
            {/* <LocationOnTwoToneIcon  fontSize='medium' /> */}
            <Typography variant='h6' fontWeight={600} ml={0.5}>{selectedCity.name}</Typography>
        </Box>
    )
})

export default CityName;